var map = {
	"./female/active/abdomen.svg": "ad42",
	"./female/active/face.svg": "2985",
	"./female/active/neck.svg": "1164",
	"./female/active/upperBody.svg": "c72b",
	"./female/non-active/abdomen.svg": "15e0",
	"./female/non-active/face.svg": "2a09",
	"./female/non-active/neck.svg": "08c1",
	"./female/non-active/upperBody.svg": "89f5",
	"./male/active/abdomen.svg": "45a0",
	"./male/active/face.svg": "bf4d",
	"./male/active/neck.svg": "6b9a",
	"./male/active/upperBody.svg": "a8c8",
	"./male/non-active/abdomen.svg": "0809",
	"./male/non-active/face.svg": "c3a7",
	"./male/non-active/neck.svg": "faa6",
	"./male/non-active/upperBody.svg": "e305",
	"./other/active/abdomen.svg": "8d00",
	"./other/active/face.svg": "a6d3",
	"./other/active/neck.svg": "2b43",
	"./other/active/upperBody.svg": "5b66",
	"./other/non-active/abdomen.svg": "3a77",
	"./other/non-active/face.svg": "158a",
	"./other/non-active/neck.svg": "6d35",
	"./other/non-active/upperBody.svg": "ded9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9bf0";